import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { createContext, useContext, type ReactNode } from 'react';

/**
 * Props spread on a wrapper inside a @hello-pangea/dnd drag handle so the inner
 * node is not treated as the full drag handle (fixes SearchSelect blur/selection under DnD).
 */
export interface RfdDragIslandProps {
  'data-rfd-drag-handle-context-id': DraggableProvidedDragHandleProps['data-rfd-drag-handle-context-id'];
}

const RfdDragIslandContext = createContext<RfdDragIslandProps | undefined>(undefined);

function getRfdDragIslandProps(
  dragHandleProps: DraggableProvidedDragHandleProps | null | undefined
): RfdDragIslandProps | undefined {
  if (dragHandleProps == null) {
    return undefined;
  }
  return { 'data-rfd-drag-handle-context-id': dragHandleProps['data-rfd-drag-handle-context-id'] };
}

export function RfdDragIslandProvider({
  dragHandleProps,
  children,
}: {
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  children: ReactNode;
}) {
  const value = getRfdDragIslandProps(dragHandleProps);
  return <RfdDragIslandContext.Provider value={value}>{children}</RfdDragIslandContext.Provider>;
}

export function useRfdDragIslandProps(): RfdDragIslandProps | undefined {
  return useContext(RfdDragIslandContext);
}
